import { css } from '@emotion/core';
import { Theme, normalText } from 'features/Theme';

const style = {
  sectionTitle: (theme: Theme) => css`
    ${normalText(theme)}
    font-weight: ${theme.mui.typography.fontWeightBold};
    margin-top: ${theme.mui.spacing(2)}px;
    margin-bottom: ${theme.mui.spacing(2)}px;
    text-align: center;
  `,
  emptyMessage: (theme: Theme) => css`
    ${normalText(theme)}
    text-align: center;
  `,
  merchantChoice: (theme: Theme) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;

    padding: ${theme.mui.spacing(2)}px;
    border-radius: ${theme.shape.borderRadiusSmall}px;
    border: 1px solid ${theme.mui.palette.divider};
    margin-bottom: ${theme.mui.spacing(1)}px;
    cursor: pointer;
  `,
  merchantBrand: () => css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  merchantIcon: (theme: Theme) => css`
    padding-left: ${theme.mui.spacing(1)}px;
    padding-right: ${theme.mui.spacing(1)}px;
  `,
  merchantLabel: (theme: Theme) => css`
    ${normalText(theme)}
    color: inherit;
    padding-left: ${theme.mui.spacing(1)}px;
  `,
};

export default style;
